<template>
  <div class="container">
    <div class="boutique floor">
      <div class="w">
        <div class="boutique_left">
          <a href="javascript:;">
            <div></div>
          </a>
        </div>
        <div class="slider">
          <swiper :options="swiperOption">
            <swiper-slide v-for="item in reMendedList" :key="item.id">
              <router-link :to="item.url" target="_blank">
                <img :src="item.image" />
              </router-link>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>
    </div>

   <!-- <div class="ranking floor clearfix">
      <div class="w clearfix">
        <div class="rankLeft">
          <div class="tit">
            <div class="left">
              <h1>排行榜</h1>
              <i></i>
            </div>
            <div class="right clearfix">
              <ul class="clearfix">
                <li>
                  <a href="javascript:;">烫金名片</a>
                </li>
                <li>
                  <a href="javascript:;">烫金名片</a>
                </li>
                <li>
                  <a href="javascript:;">烫金名片</a>
                </li>
                <li>
                  <a href="javascript:;">烫金名片</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="rank_container">
            <div class="left">
              <img src="../../assets/index/ranking/top01.png" />
            </div>
            <div class="right">
              <div class="item">
                <img src="../../assets/index/ranking/top02.png" />
                <p>精品名片-烫金名片-圆角</p>
              </div>
              <div class="item">
                <img src="../../assets/index/ranking/top03.png" />
                <p>精品名片-烫金名片-圆角</p>
              </div>
              <div class="item">
                <img src="../../assets/index/ranking/top04.png" />
                <p>精品名片-烫金名片-圆角</p>
              </div>
              <div class="item">
                <img src="../../assets/index/ranking/top05.png" />
                <p>精品名片-烫金名片-圆角</p>
              </div>
            </div>
          </div>
        </div>
        <div class="rankRight">
          <div class="tit">
            <div class="left">
              <h1>限时特惠</h1>
              <i></i>
            </div>
            <div class="right clearfix">
              <span class="timer">
                <span class="timer_item shi">8</span>
                <span class="timer_item fen">8</span>
                <span class="timer_item miao">8</span>
              </span>
            </div>
          </div>
          <div class="rank_container">
            <div class="left">
              <img src="../../assets/index/ranking/tehui.png" />
            </div>
            <div class="right">
              <div class="item">
                <img src="../../assets/index/ranking/tehui_icon.png" />
                <p>精品名片-烫金名片-圆角</p>
              </div>
              <div class="item">
                <img src="../../assets/index/ranking/tehui_icon.png" />
                <p>精品名片-烫金名片-圆角</p>
              </div>
              <div class="item">
                <img src="../../assets/index/ranking/tehui_icon.png" />
                <p>精品名片-烫金名片-圆角</p>
              </div>
              <div class="item">
                <img src="../../assets/index/ranking/tehui_icon.png" />
                <p>精品名片-烫金名片-圆角</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="floor1 floor">
      <div class="w clearfix">
        <ul class="clearfix">
          <swiper :options="swiperOption1">
            <swiper-slide>
              <li>
                <h1>展会必备</h1>
                <img src="../../assets/index/ranking/zhanhui.png" />
              </li>
            </swiper-slide>
            <swiper-slide>
              <li>
                <h1>日常办公</h1>
                <img src="../../assets/index/ranking/bangong.png" />
              </li>
            </swiper-slide>
            <swiper-slide>
              <li>
                <h1>培训套装</h1>
                <img src="../../assets/index/ranking/peixun.png" />
              </li>
            </swiper-slide>
            <swiper-slide>
              <li>
                <h1>门店套装</h1>
                <img src="../../assets/index/ranking/mendian.png" />
              </li>
            </swiper-slide>
            <swiper-slide>
              <li class="last">
                <img src="../../assets/index/ranking/ditui.png" />
              </li>
            </swiper-slide>
          </swiper>
        </ul>
      </div>
    </div>
    <div class="floor2 floor">
      <div class="w clearfix">
        <div class="title">
          <h1>当季热销</h1>
          <a href="javascript:;">查看更多 > ></a>
        </div>
        <div class="floor_content">
          <div class="left">
            <a href="javascript:;">
              <img src="../../assets/index/floor/hb1.png" />
            </a>
          </div>
          <div class="right">
            <div class="cp_left">
              <div class="top">
                <div class="top_left">
                  <h1>创意名片</h1>
                  <p>新颖的设计 凸显客户的个性</p>
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                </div>
                <div class="top_right"></div>
              </div>
              <div class="bottom">
                <div class="bottom_left">
                  <div class="bottom_left_top">
                    <img src="../../assets/index/floor/cp02.png" />
                  </div>
                  <div class="bottom_left_bottom">
                    <i>
                      ￥9元
                      <span>起/包邮</span>
                    </i>
                    <p>商务科技普通名片-规格</p>
                  </div>
                </div>
                <div class="bottom_right">
                  <div class="bottom_left_top">
                    <img src="../../assets/index/floor/cp03.png" />
                  </div>
                  <div class="bottom_left_bottom">
                    <i>
                      ￥9元
                      <span>起/包邮</span>
                    </i>
                    <p>商务宣传单页</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="cp_right">
              <div class="right_item">
                <div class="bottom_left_top">
                  <img src="../../assets/index/floor/cp03.png" />
                </div>
                <div class="bottom_left_bottom">
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                  <p>商务宣传单页</p>
                </div>
              </div>
              <div class="right_item">
                <div class="bottom_left_top">
                  <img src="../../assets/index/floor/cp03.png" />
                </div>
                <div class="bottom_left_bottom">
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                  <p>商务宣传单页</p>
                </div>
              </div>
              <div class="right_item">
                <div class="bottom_left_top">
                  <img src="../../assets/index/floor/cp03.png" />
                </div>
                <div class="bottom_left_bottom">
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                  <p>商务宣传单页</p>
                </div>
              </div>
              <div class="right_item">
                <div class="bottom_left_top">
                  <img src="../../assets/index/floor/cp03.png" />
                </div>
                <div class="bottom_left_bottom">
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                  <p>商务宣传单页</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="floor2 floor">
      <div class="w clearfix">
        <div class="title">
          <h1>热销设计</h1>
          <a href="javascript:;">查看更多 > ></a>
        </div>
        <div class="floor_content">
          <div class="left">
            <a href="javascript:;">
              <img src="../../assets/index/floor/hb2.png" />
            </a>
          </div>
          <div class="right">
            <div class="cp_left">
              <div class="top">
                <div class="top_left">
                  <h1>创意名片</h1>
                  <p>新颖的设计 凸显客户的个性</p>
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                </div>
                <div class="top_right"></div>
              </div>
              <div class="bottom">
                <div class="bottom_left">
                  <div class="bottom_left_top">
                    <img src="../../assets/index/floor/cp02.png" />
                  </div>
                  <div class="bottom_left_bottom">
                    <i>
                      ￥9元
                      <span>起/包邮</span>
                    </i>
                    <p>商务科技普通名片-规格</p>
                  </div>
                </div>
                <div class="bottom_right">
                  <div class="bottom_left_top">
                    <img src="../../assets/index/floor/cp03.png" />
                  </div>
                  <div class="bottom_left_bottom">
                    <i>
                      ￥9元
                      <span>起/包邮</span>
                    </i>
                    <p>商务宣传单页</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="cp_right">
              <div class="right_item">
                <div class="bottom_left_top">
                  <img src="../../assets/index/floor/cp03.png" />
                </div>
                <div class="bottom_left_bottom">
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                  <p>商务宣传单页</p>
                </div>
              </div>
              <div class="right_item">
                <div class="bottom_left_top">
                  <img src="../../assets/index/floor/cp03.png" />
                </div>
                <div class="bottom_left_bottom">
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                  <p>商务宣传单页</p>
                </div>
              </div>
              <div class="right_item">
                <div class="bottom_left_top">
                  <img src="../../assets/index/floor/cp03.png" />
                </div>
                <div class="bottom_left_bottom">
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                  <p>商务宣传单页</p>
                </div>
              </div>
              <div class="right_item">
                <div class="bottom_left_top">
                  <img src="../../assets/index/floor/cp03.png" />
                </div>
                <div class="bottom_left_bottom">
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                  <p>商务宣传单页</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="floor2 floor">
      <div class="w clearfix">
        <div class="title">
          <h1>热销名片</h1>
          <a href="javascript:;">查看更多 > ></a>
        </div>
        <div class="floor_content">
          <div class="left">
            <a href="javascript:;">
              <img src="../../assets/index/floor/hb3.png" />
            </a>
          </div>
          <div class="right">
            <div class="cp_left">
              <div class="top">
                <div class="top_left">
                  <h1>创意名片</h1>
                  <p>新颖的设计 凸显客户的个性</p>
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                </div>
                <div class="top_right"></div>
              </div>
              <div class="bottom">
                <div class="bottom_left">
                  <div class="bottom_left_top">
                    <img src="../../assets/index/floor/cp02.png" />
                  </div>
                  <div class="bottom_left_bottom">
                    <i>
                      ￥9元
                      <span>起/包邮</span>
                    </i>
                    <p>商务科技普通名片-规格</p>
                  </div>
                </div>
                <div class="bottom_right">
                  <div class="bottom_left_top">
                    <img src="../../assets/index/floor/cp03.png" />
                  </div>
                  <div class="bottom_left_bottom">
                    <i>
                      ￥9元
                      <span>起/包邮</span>
                    </i>
                    <p>商务宣传单页</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="cp_right">
              <div class="right_item">
                <div class="bottom_left_top">
                  <img src="../../assets/index/floor/cp03.png" />
                </div>
                <div class="bottom_left_bottom">
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                  <p>商务宣传单页</p>
                </div>
              </div>
              <div class="right_item">
                <div class="bottom_left_top">
                  <img src="../../assets/index/floor/cp03.png" />
                </div>
                <div class="bottom_left_bottom">
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                  <p>商务宣传单页</p>
                </div>
              </div>
              <div class="right_item">
                <div class="bottom_left_top">
                  <img src="../../assets/index/floor/cp03.png" />
                </div>
                <div class="bottom_left_bottom">
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                  <p>商务宣传单页</p>
                </div>
              </div>
              <div class="right_item">
                <div class="bottom_left_top">
                  <img src="../../assets/index/floor/cp03.png" />
                </div>
                <div class="bottom_left_bottom">
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                  <p>商务宣传单页</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="floor2 floor">
      <div class="w clearfix">
        <div class="title">
          <h1>常用设计</h1>
          <a href="javascript:;">查看更多 > ></a>
        </div>
        <div class="floor_content">
          <div class="left">
            <a href="javascript:;">
              <img src="../../assets/index/floor/hb4.png" />
            </a>
          </div>
          <div class="right">
            <div class="cp_left">
              <div class="top">
                <div class="top_left">
                  <h1>创意名片</h1>
                  <p>新颖的设计 凸显客户的个性</p>
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                </div>
                <div class="top_right"></div>
              </div>
              <div class="bottom">
                <div class="bottom_left">
                  <div class="bottom_left_top">
                    <img src="../../assets/index/floor/cp02.png" />
                  </div>
                  <div class="bottom_left_bottom">
                    <i>
                      ￥9元
                      <span>起/包邮</span>
                    </i>
                    <p>商务科技普通名片-规格</p>
                  </div>
                </div>
                <div class="bottom_right">
                  <div class="bottom_left_top">
                    <img src="../../assets/index/floor/cp03.png" />
                  </div>
                  <div class="bottom_left_bottom">
                    <i>
                      ￥9元
                      <span>起/包邮</span>
                    </i>
                    <p>商务宣传单页</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="cp_right">
              <div class="right_item">
                <div class="bottom_left_top">
                  <img src="../../assets/index/floor/cp03.png" />
                </div>
                <div class="bottom_left_bottom">
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                  <p>商务宣传单页</p>
                </div>
              </div>
              <div class="right_item">
                <div class="bottom_left_top">
                  <img src="../../assets/index/floor/cp03.png" />
                </div>
                <div class="bottom_left_bottom">
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                  <p>商务宣传单页</p>
                </div>
              </div>
              <div class="right_item">
                <div class="bottom_left_top">
                  <img src="../../assets/index/floor/cp03.png" />
                </div>
                <div class="bottom_left_bottom">
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                  <p>商务宣传单页</p>
                </div>
              </div>
              <div class="right_item">
                <div class="bottom_left_top">
                  <img src="../../assets/index/floor/cp03.png" />
                </div>
                <div class="bottom_left_bottom">
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                  <p>商务宣传单页</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="floor2 floor">
      <div class="w clearfix">
        <div class="title">
          <h1>宣传名片</h1>
          <a href="javascript:;">查看更多 > ></a>
        </div>
        <div class="floor_content">
          <div class="left">
            <a href="javascript:;">
              <img src="../../assets/index/floor/hb5.png" />
            </a>
          </div>
          <div class="right">
            <div class="cp_left">
              <div class="top">
                <div class="top_left">
                  <h1>创意名片</h1>
                  <p>新颖的设计 凸显客户的个性</p>
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                </div>
                <div class="top_right"></div>
              </div>
              <div class="bottom">
                <div class="bottom_left">
                  <div class="bottom_left_top">
                    <img src="../../assets/index/floor/cp02.png" />
                  </div>
                  <div class="bottom_left_bottom">
                    <i>
                      ￥9元
                      <span>起/包邮</span>
                    </i>
                    <p>商务科技普通名片-规格</p>
                  </div>
                </div>
                <div class="bottom_right">
                  <div class="bottom_left_top">
                    <img src="../../assets/index/floor/cp03.png" />
                  </div>
                  <div class="bottom_left_bottom">
                    <i>
                      ￥9元
                      <span>起/包邮</span>
                    </i>
                    <p>商务宣传单页</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="cp_right">
              <div class="right_item">
                <div class="bottom_left_top">
                  <img src="../../assets/index/floor/cp03.png" />
                </div>
                <div class="bottom_left_bottom">
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                  <p>商务宣传单页</p>
                </div>
              </div>
              <div class="right_item">
                <div class="bottom_left_top">
                  <img src="../../assets/index/floor/cp03.png" />
                </div>
                <div class="bottom_left_bottom">
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                  <p>商务宣传单页</p>
                </div>
              </div>
              <div class="right_item">
                <div class="bottom_left_top">
                  <img src="../../assets/index/floor/cp03.png" />
                </div>
                <div class="bottom_left_bottom">
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                  <p>商务宣传单页</p>
                </div>
              </div>
              <div class="right_item">
                <div class="bottom_left_top">
                  <img src="../../assets/index/floor/cp03.png" />
                </div>
                <div class="bottom_left_bottom">
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                  <p>商务宣传单页</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="floor2 floor">
      <div class="w clearfix">
        <div class="title">
          <h1>喷绘用品</h1>
          <a href="javascript:;">查看更多 > ></a>
        </div>
        <div class="floor_content">
          <div class="left">
            <a href="javascript:;">
              <img src="../../assets/index/floor/hb6.png" />
            </a>
          </div>
          <div class="right">
            <div class="cp_left">
              <div class="top">
                <div class="top_left">
                  <h1>创意名片</h1>
                  <p>新颖的设计 凸显客户的个性</p>
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                </div>
                <div class="top_right"></div>
              </div>
              <div class="bottom">
                <div class="bottom_left">
                  <div class="bottom_left_top">
                    <img src="../../assets/index/floor/cp02.png" />
                  </div>
                  <div class="bottom_left_bottom">
                    <i>
                      ￥9元
                      <span>起/包邮</span>
                    </i>
                    <p>商务科技普通名片-规格</p>
                  </div>
                </div>
                <div class="bottom_right">
                  <div class="bottom_left_top">
                    <img src="../../assets/index/floor/cp03.png" />
                  </div>
                  <div class="bottom_left_bottom">
                    <i>
                      ￥9元
                      <span>起/包邮</span>
                    </i>
                    <p>商务宣传单页</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="cp_right">
              <div class="right_item">
                <div class="bottom_left_top">
                  <img src="../../assets/index/floor/cp03.png" />
                </div>
                <div class="bottom_left_bottom">
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                  <p>商务宣传单页</p>
                </div>
              </div>
              <div class="right_item">
                <div class="bottom_left_top">
                  <img src="../../assets/index/floor/cp03.png" />
                </div>
                <div class="bottom_left_bottom">
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                  <p>商务宣传单页</p>
                </div>
              </div>
              <div class="right_item">
                <div class="bottom_left_top">
                  <img src="../../assets/index/floor/cp03.png" />
                </div>
                <div class="bottom_left_bottom">
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                  <p>商务宣传单页</p>
                </div>
              </div>
              <div class="right_item">
                <div class="bottom_left_top">
                  <img src="../../assets/index/floor/cp03.png" />
                </div>
                <div class="bottom_left_bottom">
                  <i>
                    ￥9元
                    <span>起/包邮</span>
                  </i>
                  <p>商务宣传单页</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>-->
  <!--  <div class="feeds floor">
      <div class="w">
        <div class="feedtit">猜你喜欢的</div>
        <div class="feedContent">
          <ul class="clearfix">
            <li>
              <a href="javascript:;">
                <div class="zy_img">
                  <img src="../../assets/index/floor/live.png" />
                </div>
                <div class="zy_info">折叠名片 折出您的个性，秀出更多机会</div>
                <div class="zy_price">￥ 25元起/包邮</div>
              </a>
            </li>
            <li>
              <a href="javascript:;">
                <div class="zy_img">
                  <img src="../../assets/index/floor/live.png" />
                </div>
                <div class="zy_info">折叠名片 折出您的个性，秀出更多机会</div>
                <div class="zy_price">￥ 25元起/包邮</div>
              </a>
            </li>
            <li>
              <a href="javascript:;">
                <div class="zy_img">
                  <img src="../../assets/index/floor/live.png" />
                </div>
                <div class="zy_info">折叠名片 折出您的个性，秀出更多机会</div>
                <div class="zy_price">￥ 25元起/包邮</div>
              </a>
            </li>
            <li>
              <a href="javascript:;">
                <div class="zy_img">
                  <img src="../../assets/index/floor/live.png" />
                </div>
                <div class="zy_info">折叠名片 折出您的个性，秀出更多机会</div>
                <div class="zy_price">￥ 25元起/包邮</div>
              </a>
            </li>
            <li>
              <a href="javascript:;">
                <div class="zy_img">
                  <img src="../../assets/index/floor/live.png" />
                </div>
                <div class="zy_info">折叠名片 折出您的个性，秀出更多机会</div>
                <div class="zy_price">￥ 25元起/包邮</div>
              </a>
            </li>
            <li>
              <a href="javascript:;">
                <div class="zy_img">
                  <img src="../../assets/index/floor/live.png" />
                </div>
                <div class="zy_info">折叠名片 折出您的个性，秀出更多机会</div>
                <div class="zy_price">￥ 25元起/包邮</div>
              </a>
            </li>
            <li>
              <a href="javascript:;">
                <div class="zy_img">
                  <img src="../../assets/index/floor/live.png" />
                </div>
                <div class="zy_info">折叠名片 折出您的个性，秀出更多机会</div>
                <div class="zy_price">￥ 25元起/包邮</div>
              </a>
            </li>
            <li>
              <a href="javascript:;">
                <div class="zy_img">
                  <img src="../../assets/index/floor/live.png" />
                </div>
                <div class="zy_info">折叠名片 折出您的个性，秀出更多机会</div>
                <div class="zy_price">￥ 25元起/包邮</div>
              </a>
            </li>
            <li>
              <a href="javascript:;">
                <div class="zy_img">
                  <img src="../../assets/index/floor/live.png" />
                </div>
                <div class="zy_info">折叠名片 折出您的个性，秀出更多机会</div>
                <div class="zy_price">￥ 25元起/包邮</div>
              </a>
            </li>
            <li>
              <a href="javascript:;">
                <div class="zy_img">
                  <img src="../../assets/index/floor/live.png" />
                </div>
                <div class="zy_info">折叠名片 折出您的个性，秀出更多机会</div>
                <div class="zy_price">￥ 25元起/包邮</div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
 --></div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 5,
        spaceBetween: 30,
        slidesPerGroup: 1,
        loop: true,
        loopFillGroupWithBlank: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperOption1: {
        slidesPerView: 5,
        spaceBetween: 30,
        slidesPerGroup: 1,
        loop: true,
        loopFillGroupWithBlank: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        }
      },
      reMendedList: []
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  methods: {
    // 精品推荐
    async reMended() {
      let param = new URLSearchParams()
      param.append('type', 1)
      const { data: res } = await this.$http.post('api/index/getbanner', param)
      this.reMendedList = res.data
    }
  },
  created() {
    this.reMended()
  },
  mounted() {
    setInterval(this.Countdown, 1000)
  }
}
</script>

<style lang="less" scoped>
.container {
  margin-top: 20px;
  .boutique {
    margin-top: 20px;
    display: flex;
    .w {
      background: #fff;
      .boutique_left {
        padding-top: 12px;
        width: 200px;
        height: 250px;
        float: left;
        div {
          height: 100%;
          background: url('../../assets/index/boutique/boutique_logo.png');
        }
      }
      .slider {
        position: relative;
        width: 83%;
        margin: 12px 0 5px 205px;
        .swiper-container {
          width: 100%;
          height: 250px;
        }
        .swiper-wrapper {
          width: 100%;
          height: 100%;
        }
        .swiper-slide {
          width: 33% !important;
          height: 100%;
          text-align: center;
          font-size: 18px;
          background: #fff;
          margin-right: 0 !important;
          padding-right: 10px;
          img {
            transition: 0.2s all;
            cursor: pointer;
            height: 100%;
            width: 100%;
          }
          img:hover {
            opacity: 0.7;
          }
        }
        .arrow-left {
          top: 102px;
          left: -5px;
        }
        .arrow-right {
          top: 102px;
          right: 204px;
        }
      }
    }
  }
  .ranking {
    margin-top: 20px;
    .w {
      background: #fff;
      .rankLeft,
      .rankRight {
        width: 645px;
        height: 352px;
        float: left;
      }
      .rankLeft,
      .rankRight {
        box-sizing: border-box;
        padding: 0px 10px 12px 15px;
        background: #fff;
        margin-right: 10px;
        .tit {
          height: 58px;
          line-height: 58px;
          display: flex;
          .left {
            position: relative;
            width: 120px;
            h1 {
              font-size: 22px;
              color: #333;
            }
            i {
              position: absolute;
              top: 22px;
              left: 75px;
              width: 17px;
              height: 17px;
              background: url('../../assets/index/ranking/jiantou_icon.png')
                no-repeat;
            }
          }
          .right {
            width: 100%;
            ul {
              float: right;
              li {
                float: left;
                margin-left: 20px;
                a {
                  font-size: 14px;
                  color: #999;
                }
                a:hover {
                  color: #a77c5a;
                }
              }
            }
          }
        }
        .rank_container {
          height: 282px;
          width: 100%;
          background: #fff;
          display: flex;
          .left {
            position: relative;
            width: 250px;
            height: 100%;
            background: url('../../assets/index/ranking/big_img.png') center
              no-repeat;
            background-size: 118%;
            margin-right: 10px;
            transition: all 0.2s;
            cursor: pointer;
          }
          .left:hover {
            opacity: 0.7;
          }
          .right {
            width: 100%;
            height: 100%;
            display: flex;
            flex-wrap: wrap;
            .item {
              flex: 49%;
              background: url('../../assets/index/ranking/small_img.png')
                no-repeat center;
              position: relative;
              box-sizing: border-box;
              -ms-box-sizing: border-box;
              border: 1px solid #f4f4f4;
              cursor: pointer;
              img {
                position: absolute;
                top: 0;
                left: 8px;
              }
              p {
                position: absolute;
                bottom: 0;
                left: 25px;
              }
            }
            .item:hover {
              opacity: 0.7;
            }
          }
        }
      }
      .rankRight {
        .rank_container {
          .left {
            background: url('../../assets/index/ranking/yaoqing.png') no-repeat
              center;
          }
        }
        margin-right: 0;
        .tit {
          .left {
            i {
              position: absolute;
              top: 22px;
              left: 95px;
            }
          }
          .right {
            position: relative;
            .timer {
              position: absolute;
              top: 20px;
              right: 0;
              display: block;
              width: 135px;
              height: 26px;
              .timer_item {
                display: block;
                float: left;
                width: 30px;
                height: 26px;
                line-height: 26px;
                text-align: center;
                font-weight: bold;
                background: #000;
                color: #fff;
                margin-right: 15px;
                position: relative;
                font-size: 14px;
              }
              .timer_item::after {
                content: ':';
                font-size: 14px;
                display: block;
                width: 20px;
                height: 26px;
                position: absolute;
                top: 0;
                left: 28px;
                color: #000;
              }
              .timer_item:nth-child(3)::after {
                content: '';
              }
            }
          }
        }
      }
    }
  }
  .floor1 {
    margin-top: 20px;
    .w {
      height: 320px;
      ul {
        width: 1210px;
        position: relative;
        .swiper-slide {
          width: 260px !important;
        }
        li {
          background: #fff;
          box-sizing: border-box;
          float: left;
          margin-right: 10px;
          width: 272px;
          height: 320px;
          padding: 15px 10px 20px;
          h1 {
            height: 44px;
            line-height: 44px;
            font-size: 22px;
            color: #333;
            font-weight: 600;
          }
        }
        .last {
          img {
            margin-top: 10px;
          }
        }
      }
    }
  }
  .floor2 {
    margin-top: 20px;
    .w {
      box-sizing: border-box;
      height: 480px;
      background: #fff;
      padding: 0 10px 10px 10px;
      .title {
        display: flex;
        height: 58px;
        line-height: 58px;
        justify-content: space-between;
        h1 {
          font-size: 22px;
          color: #333;
          font-weight: bold;
        }
        a {
          float: right;
          font-size: 14px;
          color: #999;
        }
        a:hover {
          color: #a77c5a;
        }
      }
      .floor_content {
        height: 422px;
        .left {
          float: left;
          width: 200px;
          height: 100%;
          margin-right: 10px;
        }
        .right {
          float: right;
          width: 970px;
          height: 412px;
          display: flex;
          .cp_left {
            width: 485px;
            height: 412px;
            background-color: #f7f9fa;
            .top {
              width: 485px;
              height: 208px;
              display: flex;
              justify-content: space-between;
              box-sizing: border-box;
              border-right: 1px solid #dfe2e3;
              border-bottom: 1px solid #dfe2e3;
              transition: 0.2s all;
              cursor: pointer;
              .top_left,
              .top_right {
                width: 50%;
                height: 208px;
              }
              .top_left {
                padding-top: 45px;
                padding-left: 25px;
                h1 {
                  font-size: 22px;
                  font-weight: bold;
                }
                p {
                  margin-top: 10px;
                  font-size: 14px;
                  color: #999;
                  margin-bottom: 20px;
                }
                i {
                  font-size: 22px;
                  color: #e83030;
                  font-weight: bold;
                  font-style: italic;
                  span {
                    font-size: 16px;
                    font-style: normal;
                  }
                }
              }
              .top_right {
                background: url('../../assets/index/floor/cp01.png') no-repeat
                  center;
              }
            }
            .top:hover {
              opacity: 0.7;
            }
            .bottom {
              width: 485px;
              height: 202px;
              display: flex;
              justify-content: space-between;
              box-sizing: border-box;
              border-right: 1px solid #dfe2e3;
              border-bottom: 1px solid #dfe2e3;
              .bottom_left,
              .bottom_right {
                box-sizing: border-box;
                border-right: 1px solid #dfe2e3;
                border-bottom: 1px solid #dfe2e3;
                margin-left: 40px;
                width: 50%;
                height: 202px;
                transition: 0.2s all;
                cursor: pointer;
                .bottom_left_top {
                  text-align: center;
                  margin-top: 12px;
                }
                .bottom_left_bottom {
                  margin-top: 15px;
                  i {
                    font-size: 22px;
                    color: #e83030;
                    font-style: italic;
                    font-weight: bold;
                    span {
                      font-style: normal;
                      font-size: 16px;
                    }
                  }
                  p {
                    font-size: 14px;
                    color: #666;
                    margin-top: 5px;
                  }
                }
              }
              .bottom_left:hover,
              .bottom_right:hover {
                opacity: 0.7;
              }
            }
          }
          .cp_right {
            background-color: #f7f9fa;
            width: 482px;
            height: 412px;
            display: flex;
            flex-wrap: wrap;
            .right_item {
              box-sizing: border-box;
              border-right: 1px solid #dfe2e3;
              border-bottom: 1px solid #dfe2e3;
              flex: 49%;
              transition: 0.2s all;
              cursor: pointer;
              .bottom_left_top {
                text-align: center;
                img {
                  margin-top: 12px;
                }
              }
              .bottom_left_bottom {
                padding-left: 20px;
                margin-top: 15px;
                i {
                  font-size: 22px;
                  color: #e83030;
                  font-style: italic;
                  font-weight: bold;
                  span {
                    font-style: normal;
                    font-size: 16px;
                  }
                }
                p {
                  font-size: 14px;
                  color: #666;
                  margin-top: 5px;
                }
              }
            }
            .right_item:hover {
              opacity: 0.7;
            }
          }
        }
      }
    }
  }
  .feeds {
    height: 660px;
    .w {
      height: 660px;
      .feedtit {
        height: 66px;
        line-height: 66px;
        text-align: center;
        font-size: 22px;
        color: '#333';
      }
      .feedContent {
        ul {
          width: 1210px;
          display: flex;
          flex-wrap: wrap;
          li {
            box-sizing: border-box;
            height: 290px;
            flex: 19%;
            background: #fff;
            margin-right: 10px;
            margin-bottom: 10px;
            transition: 0.2s all;
            a {
              display: block;
              padding: 0 12px;
              .zy_img {
                margin: 12px 0px;
              }
              .zy_info {
                color: #666;
                font-size: 14px;
              }
              .zy_price {
                margin-top: 13px;
                color: #e83030;
                font-size: 14px;
              }
            }
          }
          li:hover {
            cursor: pointer;
            opacity: 0.7;
          }
        }
      }
    }
  }
}
</style>
